// extracted by mini-css-extract-plugin
module.exports = {"modalInputLabel":"_2kSEeRYF","required":"q-yKkB85"};